import type { AssistantEvent } from './types'

export async function readAssistantStream(response: Response, onEvent: (event: AssistantEvent) => void) {
  if (!response.ok || !response.body) throw new Error('Motion could not reconnect to this response.')
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let completed = false
  const emit = (line: string) => {
    const event = JSON.parse(line) as AssistantEvent
    if (event.type === 'done') completed = true
    onEvent(event)
  }
  try {
    while (true) {
      const { done, value } = await reader.read()
      buffer += decoder.decode(value, { stream: !done })
      const lines = buffer.split('\n')
      buffer = lines.pop() || ''
      for (const line of lines) if (line.trim()) emit(line)
      if (done) {
        if (buffer.trim()) emit(buffer)
        if (!completed) throw new Error('Response stream interrupted.')
        return
      }
    }
  } finally { reader.releaseLock() }
}
